import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AlertComponent } from "../component/alert/alert.component";

@Injectable({
  providedIn: "root",
})
export class AlertService {
  constructor(private snackBar: MatSnackBar) {}

  private openCustomSnackbar(message: string, messageType: string) {
    this.snackBar.openFromComponent(AlertComponent, {
      data: {
        message: message,
        messageType: messageType,
      },
      horizontalPosition: "right",
      verticalPosition: "top",
      duration: 5000,
      panelClass: "snackbar",
    });
  }

  showSuccess(message: string) {
    this.openCustomSnackbar(message, "success");
  }

  showError(message: string) {
    this.openCustomSnackbar(message, "error");
  }

  showWarning(message: string) {
    this.openCustomSnackbar(message, "warning");
  }
}
